<template>
  <div id="app">
    <div v-if="localMode" class="alert alert-warning text-center mb-0" role="status">LOCAL DEVELOPMENT · {{ dataLabel }} · {{ stripeLabel }} · Email delivery disabled</div>
    <router-view/>
  </div>
</template>

<script>
export default { computed: {
  localMode: () => ['mock', 'test'].includes(process.env.VUE_APP_STRIPE_MODE),
  dataLabel: () => process.env.VUE_APP_LOCAL_DATA_KIND === 'restored' ? 'Sanitized production snapshot' : 'Synthetic team data',
  stripeLabel: () => process.env.VUE_APP_STRIPE_MODE === 'test' ? 'Stripe TEST mode — no real money' : 'Stripe simulator',
} }
</script>

<style lang="scss">
</style>
